import { render, staticRenderFns } from "./VendorListBox.vue?vue&type=template&id=ec16e0c4"
import script from "./VendorListBox.vue?vue&type=script&lang=js"
export * from "./VendorListBox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports